import { render, staticRenderFns } from "./TournamentTimer.vue?vue&type=template&id=0a81e1a1&scoped=true"
import script from "./TournamentTimer.vue?vue&type=script&lang=js"
export * from "./TournamentTimer.vue?vue&type=script&lang=js"
import style0 from "./TournamentTimer.vue?vue&type=style&index=0&id=0a81e1a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a81e1a1",
  null
  
)

export default component.exports